// src/services/userDataService.js - SHİPPİNGFEE DÜZELTİLMİŞ
import { 
  doc, 
  getDoc, 
  setDoc, 
  updateDoc, 
  serverTimestamp,
  writeBatch,
  increment
} from 'firebase/firestore';
import { db } from '../firebase';
// ==================== HELPER FUNCTIONS ====================

/**
 * Kullanıcının giriş yapıp yapmadığını kontrol et
 */
export const isUserLoggedIn = () => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const userId = localStorage.getItem('userId');
  return isLoggedIn && userId;
};

/**
 * Kullanıcı ID'sini al
 */
export const getUserId = () => {
  return localStorage.getItem('userId');
};

/**
 * Kullanıcı dokümanını al veya oluştur
 */
const getUserDocument = async (userId) => {
  try {
    const userRef = doc(db, 'Users', userId);
    const userSnap = await getDoc(userRef);
    
    if (!userSnap.exists()) {
      // Kullanıcı dokümanı yoksa oluştur
      await setDoc(userRef, {
        uid: userId,
        cart: [],
        wishlist: [],
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
      return { cart: [], wishlist: [] };
    }
    
    return userSnap.data();
  } catch (error) {
    console.error('getUserDocument error:', error);
    throw error;
  }
};

// ==================== FAVORİLER YÖNETİMİ ====================

/**
 * Favorileri Firestore'dan yükle
 */
export const loadWishlistFromFirestore = async () => {
  try {
    if (!isUserLoggedIn()) {
      console.log('Kullanıcı giriş yapmamış, localStorage kullanılıyor');
      return { success: false, useLocalStorage: true };
    }

    const userId = getUserId();
    const userData = await getUserDocument(userId);
    
    return { 
      success: true, 
      wishlist: userData.wishlist || [],
      useLocalStorage: false 
    };
  } catch (error) {
    console.error('loadWishlistFromFirestore error:', error);
    return { success: false, error: error.message, useLocalStorage: true };
  }
};

/**
 * Favorilere ürün ekle (Firestore) - Likes sayacını artırır
 */
export const addToWishlistFirestore = async (product) => {
  try {
    if (!isUserLoggedIn()) {
      return { success: false, useLocalStorage: true };
    }

    const userId = getUserId();
    const userRef = doc(db, 'Users', userId);
    const productRef = doc(db, 'Products', product.id);
    const userData = await getUserDocument(userId);
    
    const updatedWishlist = [...(userData.wishlist || [])];
    const exists = updatedWishlist.find(item => item.id === product.id);
    
    if (exists) {
      // Zaten varsa ekleme
      return { success: true, wishlist: updatedWishlist, alreadyExists: true };
    }
    
    // Yeni ürün ekle
    updatedWishlist.push({
      id: product.id,
      name: product.name,
      price: product.price,
      image: product.image,
      discount: product.discount || 0,
      category: product.category,
      description: product.description,
      rating: product.rating,
      addedAt: new Date().toISOString()
    });
    
    // 🔥 Batch işlem: Hem Users hem Products güncelle
    const batch = writeBatch(db);
    
    // Users collection'ı güncelle
    batch.update(userRef, {
      wishlist: updatedWishlist,
      updatedAt: serverTimestamp()
    });
    
    // Products collection'daki likes sayacını artır
    batch.update(productRef, {
      likes: increment(1)
    });
    
    await batch.commit();
    
    console.log('✅ Ürün favorilere eklendi, likes sayacı artırıldı:', product.id);
    
    return { success: true, wishlist: updatedWishlist };
  } catch (error) {
    console.error('addToWishlistFirestore error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Favorilerden ürün çıkar (Firestore) - Likes sayacını azaltır
 */
export const removeFromWishlistFirestore = async (productId) => {
  try {
    if (!isUserLoggedIn()) {
      return { success: false, useLocalStorage: true };
    }

    const userId = getUserId();
    const userRef = doc(db, 'Users', userId);
    const productRef = doc(db, 'Products', productId);
    const userData = await getUserDocument(userId);
    
    const updatedWishlist = (userData.wishlist || []).filter(item => item.id !== productId);
    
    // 🔥 Batch işlem: Hem Users hem Products güncelle
    const batch = writeBatch(db);
    
    // Users collection'ı güncelle
    batch.update(userRef, {
      wishlist: updatedWishlist,
      updatedAt: serverTimestamp()
    });
    
    // Products collection'daki likes sayacını azalt
    batch.update(productRef, {
      likes: increment(-1)
    });
    
    await batch.commit();
    
    console.log('✅ Ürün favorilerden çıkarıldı, likes sayacı azaltıldı:', productId);
    
    return { success: true, wishlist: updatedWishlist };
  } catch (error) {
    console.error('removeFromWishlistFirestore error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Favorileri toggle (ekle/çıkar) (Firestore) - Likes sayacını günceller
 */
export const toggleWishlistFirestore = async (product) => {
  try {
    if (!isUserLoggedIn()) {
      return { success: false, useLocalStorage: true };
    }

    const userId = getUserId();
    const userRef = doc(db, 'Users', userId);
    const productRef = doc(db, 'Products', product.id);
    const userData = await getUserDocument(userId);
    
    let updatedWishlist = [...(userData.wishlist || [])];
    const existingIndex = updatedWishlist.findIndex(item => item.id === product.id);
    
    // 🔥 Batch işlem başlat
    const batch = writeBatch(db);
    
    if (existingIndex > -1) {
      // ❌ VARSA ÇIKAR - Likes azalt
      updatedWishlist = updatedWishlist.filter(item => item.id !== product.id);
      
      batch.update(userRef, {
        wishlist: updatedWishlist,
        updatedAt: serverTimestamp()
      });
      
      batch.update(productRef, {
        likes: increment(-1)
      });
      
      await batch.commit();
      console.log('✅ Ürün favorilerden çıkarıldı, likes: -1', product.id);
      
    } else {
      // ✅ YOKSA EKLE - Likes artır
      updatedWishlist.push({
        id: product.id,
        name: product.name,
        price: product.price,
        image: product.image,
        discount: product.discount || 0,
        category: product.category,
        description: product.description,
        rating: product.rating,
        addedAt: new Date().toISOString()
      });
      
      batch.update(userRef, {
        wishlist: updatedWishlist,
        updatedAt: serverTimestamp()
      });
      
      batch.update(productRef, {
        likes: increment(1)
      });
      
      await batch.commit();
      console.log('✅ Ürün favorilere eklendi, likes: +1', product.id);
    }
    
    return { success: true, wishlist: updatedWishlist };
  } catch (error) {
    console.error('toggleWishlistFirestore error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Tüm favorileri temizle (Firestore) - Tüm ürünlerin likes sayacını azaltır
 */
export const clearWishlistFirestore = async () => {
  try {
    if (!isUserLoggedIn()) {
      return { success: false, useLocalStorage: true };
    }

    const userId = getUserId();
    const userRef = doc(db, 'Users', userId);
    const userData = await getUserDocument(userId);
    
    const currentWishlist = userData.wishlist || [];
    
    if (currentWishlist.length === 0) {
      return { success: true };
    }
    
    // 🔥 Batch işlem: Tüm ürünlerin likes'ını azalt
    const batch = writeBatch(db);
    
    // Her ürünün likes sayacını azalt
    currentWishlist.forEach(item => {
      const productRef = doc(db, 'Products', item.id);
      batch.update(productRef, {
        likes: increment(-1)
      });
    });
    
    // Users collection'ı temizle
    batch.update(userRef, {
      wishlist: [],
      updatedAt: serverTimestamp()
    });
    
    await batch.commit();
    
    console.log(`✅ ${currentWishlist.length} ürünün favorisi temizlendi, likes sayaçları güncellendi`);
    
    return { success: true };
  } catch (error) {
    console.error('clearWishlistFirestore error:', error);
    return { success: false, error: error.message };
  }
};

// ==================== MİGRASYON FONKSİYONLARI ====================

/**
 * localStorage'dan Firestore'a veri taşı - Likes sayaçlarını güncelle
 */
export const migrateLocalStorageToFirestore = async () => {
  try {
    if (!isUserLoggedIn()) {
      console.log('Kullanıcı giriş yapmamış, migrasyon yapılamaz');
      return { success: false };
    }

    const userId = getUserId();
    const userRef = doc(db, 'Users', userId);
    
    // localStorage'dan verileri al
    const localCart = JSON.parse(localStorage.getItem('trona_cart') || '[]');
    const localWishlist = JSON.parse(localStorage.getItem('trona_wishlist') || '[]');
    
    if (localCart.length === 0 && localWishlist.length === 0) {
      console.log('localStorage boş, migrasyon gerekmiyor');
      return { success: true, migrated: false };
    }
    
    // Firestore'daki mevcut verileri al
    const userData = await getUserDocument(userId);
    const existingCart = userData.cart || [];
    const existingWishlist = userData.wishlist || [];
    
    // Sepeti birleştir
    const mergedCart = [...existingCart];
    localCart.forEach(localItem => {
      const exists = mergedCart.find(item => item.id === localItem.id);
      if (!exists) {
        mergedCart.push(localItem);
      } else {
        const index = mergedCart.findIndex(item => item.id === localItem.id);
        mergedCart[index].quantity = (mergedCart[index].quantity || 1) + (localItem.quantity || 1);
      }
    });
    
    // 🔥 Wishlist'i birleştir - Yeni eklenen ürünler için likes artır
    const mergedWishlist = [...existingWishlist];
    const newWishlistItems = []; // Likes artırılacak ürünler
    
    localWishlist.forEach(localItem => {
      const exists = mergedWishlist.find(item => item.id === localItem.id);
      if (!exists) {
        mergedWishlist.push(localItem);
        newWishlistItems.push(localItem.id); // Bu ürünün likes'ı artırılacak
      }
    });
    
    // 🔥 Batch işlem: Users ve Products güncelle
    const batch = writeBatch(db);
    
    // Users collection'ı güncelle
    batch.update(userRef, {
      cart: mergedCart,
      wishlist: mergedWishlist,
      updatedAt: serverTimestamp()
    });
    
    // Yeni eklenen wishlist ürünlerinin likes sayacını artır
    newWishlistItems.forEach(productId => {
      const productRef = doc(db, 'Products', productId);
      batch.update(productRef, {
        likes: increment(1)
      });
    });
    
    await batch.commit();
    
    // localStorage'ı temizle
    localStorage.removeItem('trona_cart');
    localStorage.removeItem('trona_wishlist');
    
    console.log('✅ Migrasyon başarılı:', {
      cartItems: mergedCart.length,
      wishlistItems: mergedWishlist.length,
      likesUpdated: newWishlistItems.length
    });
    
    return { 
      success: true, 
      migrated: true,
      cart: mergedCart,
      wishlist: mergedWishlist,
      likesUpdated: newWishlistItems.length
    };
  } catch (error) {
    console.error('migrateLocalStorageToFirestore error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Firestore'dan localStorage'a veri taşı (çıkış yapıldığında)
 */
export const migrateFirestoreToLocalStorage = async () => {
  try {
    if (!isUserLoggedIn()) {
      return { success: false };
    }

    const userId = getUserId();
    const userData = await getUserDocument(userId);
    
    localStorage.setItem('trona_cart', JSON.stringify(userData.cart || []));
    localStorage.setItem('trona_wishlist', JSON.stringify(userData.wishlist || []));
    
    console.log('✅ Firestore → localStorage kopyalama başarılı');
    
    return { success: true };
  } catch (error) {
    console.error('migrateFirestoreToLocalStorage error:', error);
    return { success: false, error: error.message };
  }
};

// ==================== EXPORT ====================

export default {
  // Helper
  isUserLoggedIn,
  getUserId,
  
  // Wishlist
  loadWishlistFromFirestore,
  addToWishlistFirestore,
  removeFromWishlistFirestore,
  toggleWishlistFirestore,
  clearWishlistFirestore,
};